import { createContext } from 'react';

export const InitialState = {
  startGenerateInvoiceXslJob: () => {},
  clearJobId: () => {},
  jobId: null,
  filename: null,
  url: null,
  message: null,
  loading: false,
  jobErrors: []
};

export const GenerateInvoiceXslJobContext = createContext(InitialState);

GenerateInvoiceXslJobContext.displayName = 'GenerateInvoiceXslJobContext';
